var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 37C61 50.2548 50.2548 61 37 61C23.7452 61 13 50.2548 13 37C13 23.7452 23.7452 13 37 13C50.2548 13 61 23.7452 61 37ZM25 37C25 43.6274 30.3726 49 37 49C43.6274 49 49 43.6274 49 37C49 30.3726 43.6274 25 37 25C30.3726 25 25 30.3726 25 37Z",
    fill: "#00B42A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3064 18.8421C18.0407 21.6645 15.5967 25.3154 14.2317 29.4102C12.8667 33.505 12.6313 37.8921 13.5502 42.1095C14.4691 46.3268 16.5084 50.2183 19.4532 53.374C22.398 56.5297 26.1393 58.8329 30.2831 60.0409C34.4269 61.2489 38.8198 61.317 42.9991 60.2381C47.1784 59.1592 50.9894 56.9732 54.0306 53.9103C57.0719 50.8474 59.2308 47.021 60.2801 42.8342C61.3293 38.6474 61.2301 34.2551 59.9927 30.1199L48.4964 33.56C49.115 35.6275 49.1647 37.8237 48.64 39.9171C48.1154 42.0105 47.0359 43.9237 45.5153 45.4551C43.9947 46.9866 42.0892 48.0796 39.9996 48.6191C37.9099 49.1585 35.7135 49.1245 33.6416 48.5205C31.5697 47.9165 29.699 46.7649 28.2266 45.187C26.7542 43.6091 25.7346 41.6634 25.2751 39.5547C24.8156 37.4461 24.9334 35.2525 25.6159 33.2051C26.2984 31.1577 27.5204 29.3323 29.1532 27.921L21.3064 18.8421Z",
    fill: "#4285F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.06ff11e5c949f20e836832dabd604fcf.svg";
export { ForwardRef as ReactComponent };